// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartFormHTML.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * ReportPartFormHTML component
 */
!(function() {
  var React = require('react');
  var observer = require('mobx-react').observer;
  var classnames = require('classnames');
  var EventsUtils = require('EventUtils');
  var CodeMirror = require('share/components/controls/CodeMirror/Izenda.CodeMirror');
  var constants = require('logic/data/Izenda.ReportPartFormConstants');
  var { getOr } = require('lodash/fp');

  var ReportPartFormHTML = React.createClass({
    propTypes: {
      reportPart: React.PropTypes.object
    },

    handleChange: function (value) {
      var store = this.props.store;
      var reportPart = this.props.reportPart;
      var reportPartContent = reportPart.reportPartContent;

      reportPartContent.setHTMLContent && reportPartContent.setHTMLContent(value);
      store.model.markDirty();
    },

    componentDidMount: function() {
      var content = this.props.reportPart.reportPartContent;
      var editor = this.refs.codeEditor || {};
      content.setEditorControl(editor);
    },

    render: function() {
      var notifyChange = EventsUtils.notifyChange;
      var reportPartContent = this.props.reportPart.reportPartContent;
      reportPartContent.convertRepeaterTag(0, constants.TAB_HTML.key);
      var useCodeMirror =  getOr(true, 'properties.highlightCode', reportPartContent);
      var options = {
        lineNumbers: true,
        lineWrapping:  getOr(true, 'properties.wrapText', reportPartContent),
        mode: 'text/html',
        highlightSelectionMatches: true,
        indentUnit: 2,
        matchBrackets: true
      };

      var classes = classnames('report-part-form-html', {'can-drop': this.props.canDrop});

      return (
        <div className={classes}>
        { useCodeMirror
          ? <CodeMirror
              onChange={this.handleChange}
              value={reportPartContent.htmlContent}
              reportPartContent={reportPartContent}
              options={options}
              ref='codeEditor' />
          : <textarea name='form'
              onChange={notifyChange(this.handleChange, EventsUtils.INPUT)}
              defaultValue={reportPartContent.htmlContent} />
        }
        </div>
      );
    }
  });

  module.exports = observer(ReportPartFormHTML);
}());



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/ReportPartType/ReportPartForm/Izenda.ReportPartFormHTML.jsx